import { Action, Reducer } from "redux";
import { SiteInfo } from "../entities/CollectEntities";
import { AppThunkAction } from "./";

// -----------------------------------------------------------------------------------------------
// state

export interface CollectState {
    siteInfo: SiteInfo;
}

// ------------------------------------------------------------------------------------------------
// actions

const SET_SITEINFO = "SET_SITEINFO";

interface SetSiteInfoAction {
    type: typeof SET_SITEINFO;
    siteInfo: SiteInfo;
}

type KnownAction = SetSiteInfoAction

export const actionCreators = {
    setSiteInfo: (siteInfo: SiteInfo): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({
            type: SET_SITEINFO,
            siteInfo
        })
    }
}

// ------------------------------------------------------------------------------------------------
// reducer

export const reducer: Reducer<CollectState, KnownAction> = (state: CollectState | undefined, incomingAction: Action): CollectState => {

    if (state === undefined) {
        return {
            siteInfo: null
        }
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case SET_SITEINFO:
            return {
                ...state,
                siteInfo: action.siteInfo
            }
        default:
            return state;
    }
}